// libraries
import { memo, ReactElement } from 'react'
import _ from 'lodash'

// constants
import { THEMES } from 'constants/colour'

// components
import {
  EmptyList,
  Loading,
  EmptySearch,
  ListErrorHandler,
  TreeDataGrid,
} from 'components/common'

import type { ListConditions } from 'types/common'
import type { TreeDataGridProps } from 'components/common/TreeDataGrid/types'
import type { GridRowModel } from '@mui/x-data-grid-premium'

type ListTreeProps<T extends GridRowModel = GridRowModel> = Partial<
  TreeDataGridProps<T>
> & {
  title: string
  options?: ListConditions
  emptyState: ReactElement
}

const ListTree = memo(
  ({
    title,
    options: { ascOrder, isSearching, ...otherOptions } = {},
    list = [],
    emptyState,
    itemActions,
    tableLoading,
    ...rest
  }: ListTreeProps): ReactElement => {
    if (_.isEmpty(list) && !tableLoading) {
      return isSearching ? (
        <EmptySearch />
      ) : (
        <EmptyList content={title} theme={THEMES.light} render={emptyState} />
      )
    }

    return (
      <TreeDataGrid
        {...rest}
        {...otherOptions}
        list={list}
        loading={tableLoading}
        itemActions={itemActions}
      />
    )
  }
)

const TreeListDataGridPro = ({
  loading,
  onCancel,
  error,
  ...rest
}: ListTreeProps & {
  onCancel?: () => void
  error?: Error
}): ReactElement => (
  <ListErrorHandler error={_.isEmpty(rest.list) && error ? error : undefined}>
    {loading ? (
      <Loading onClick={onCancel} buttonContent='Pause Loading' />
    ) : (
      <ListTree {...rest} />
    )}
  </ListErrorHandler>
)

export default TreeListDataGridPro
